import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.linkTo,
    class: {
			'mr-6 text-gray-600 hover:text-primary active:text-primary flex flex-row items-center transition ease-out duration-300 py-4':
				_ctx.linkType === 'default',
			'text-white hover:bg-white hover:bg-opacity-25 flex flex-row items-center p-2 rounded transition ease-out-in duration-300 mb-1':
				_ctx.linkType === 'inverted',
		},
    "exact-active-class": 
			_ctx.linkType === 'default'
				? `text-primary`
				: `text-white bg-dark-primary hover:bg-dark-primary hover:bg-opacity-100`
		
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["to", "class", "exact-active-class"]))
}